import React from 'react';
import { Box } from '@mui/material';

import EmployeeCard from './EmployeeCard';

const EmployeeStatusCardComponent = (props) => {
  const {
    allEmpDetails,
    EmployeeDetails,
    ShowErrorMessageDob,
    isHr,
    ShowErrorMessageDoj,
    ShowErrorMessageDoi,
    ShowErrorMessageOEmail,
    ShowErrorMessagePEmail,
    ShowErrorMessagePhoneNo,
    ShowErrorMessage,
    Files,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
    designationNames,
    officeLocations,
    leaveGroups,
    reportingManagers,
  } = props;

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        paddingTop: '2rem',
      }}
    >
      {allEmpDetails.map((employee, index) => (
        <EmployeeCard
          designationNames={designationNames}
          officeLocations={officeLocations}
          leaveGroups={leaveGroups}
          reportingManagers={reportingManagers}
          isHr={isHr}
          key={index}
          handleToggle={handleToggle}
          selectedStatus={selectedStatus}
          Files={Files}
          employee={employee}
          UpdatedEmployeePhoto={employee?.photoPath}
          allEmployeesDetails={allEmployeesDetails}
          EmployeeDetails={EmployeeDetails}
          ShowErrorMessage={ShowErrorMessage}
          ShowErrorMessageDob={ShowErrorMessageDob}
          ShowErrorMessageDoj={ShowErrorMessageDoj}
          ShowErrorMessageDoi={ShowErrorMessageDoi}
          ShowErrorMessagOEmail={ShowErrorMessageOEmail}
          ShowErrorMessagPEmail={ShowErrorMessagePEmail}
          ShowErrorMessagePhoneNo={ShowErrorMessagePhoneNo}
        />
      ))}
    </Box>
  );
};
export default EmployeeStatusCardComponent;
